<template>
    <div class="questionPage">
        <homeHeader title="调查问卷">
            
        </homeHeader>
        <div class="homeRightContent">
            <div class="handleBars">
                <div>
                    <el-button type="primary" @click="goCreateEnroll">创建调查问卷</el-button>
                    <el-button @click="onBatchDelete">删除</el-button>
                    <el-button @click="onBatchClear">清空</el-button>
                </div>
                <div>
                    <div class="handleBarItem">
                        <span>问卷名称</span>
                        <el-input style="width: 240px;" v-model="searchForm.searchText" placeholder="请输入关键字"></el-input>
                    </div>
                    <el-button type="primary" @click="onSearch">查询</el-button>
                </div>
            </div>
            <div class="tableContainer">
                <el-table width="100%" height="100%" class="questionTable" :data="tableData" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="ID" prop="id" width="80"></el-table-column>
                    <el-table-column label="问卷名称" prop="title" min-width="200"></el-table-column>
                    <el-table-column label="绑定直播间" prop="totalNum" width="100">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.activityNum === 0" type="primary" :underline="false" @click="bindActivity(scope.row)">绑定直播间</el-link>
                            <el-popover v-else placement="right" width="380" trigger="click" popper-class="bindActivityPopper">
                                <el-link slot="reference" type="primary" :underline="false"
                                    @click="onBindActivityListShow(scope.row)">{{ scope.row.activityNum }}</el-link>
                                <div class="bindActivityList" v-if="scope.row.interactionSurveyList && scope.row.interactionSurveyList.length > 0">
                                    <div class="bindActivityItem" v-for="item in scope.row.interactionSurveyList" :key="item.id">
                                        <div>
                                            <div class="activityTitle">
                                                {{ item.activityTitle }}
                                            </div>
                                            <div class="activityId">
                                                ID:{{ item.activityId }}
                                            </div>
                                        </div>
                                        <div>
                                            <el-link type="primary" :underline="false"
                                                @click="onBindActivityUnbind(item)">解绑</el-link>
                                        </div>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="填写人数" prop="totalNum" min-width="80"></el-table-column>
                    <el-table-column label="创建时间" prop="createDate" min-width="180"></el-table-column>
                    <el-table-column label="操作" width="300">
                        <template slot-scope="scope">
                            <div style="display: flex; align-items: center; gap: 16px;">
                                <el-link type="primary" :underline="false" @click="bindActivity(scope.row)">绑定直播间</el-link>
                                <el-link type="primary" :underline="false" @click="goEditEnroll(scope.row)">编辑</el-link>
                                <el-link type="danger" :underline="false" @click="deleteEnroll(scope.row)">删除</el-link>
                                <el-link type="primary" :underline="false"
                                    @click="handleCommand('statistics', scope.row)">数据</el-link>
                                <el-link type="primary" :underline="false"
                                    @click="handleCommand('copy', scope.row)">复制</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination layout="total, prev, pager, next" :current-page.sync="searchForm.pageNum"
                :page-size.sync="searchForm.pageSize" :total="total" @current-change="getQuestionList">
            </el-pagination>


            <el-dialog :visible.sync="editDialogVisible" width="520px" class="editDialog" :show-close="false">
                <span>
                    <svg class="iconpark-icon">
                        <use href="#tixing"></use>
                    </svg>
                    <span class="text">编辑问卷可能导致已填结果出现偏差,请慎重选择,建议您复制问卷后进行编辑</span>
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" plain @click="copyEditHandle">复制后编辑</el-button>
                    <el-button type="primary" @click="editHandle">直接编辑</el-button>
                    <el-button @click="editDialogVisible = false">取消</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="shareDialogVisible" title="分享" class="shareDialog" width="600px">
                <span>
                    <el-row>
                        <el-col :span="16">
                            <p>社交网络分享</p>
                            <share :config="config" />
                            <p id="text">直接访问网址</p>
                            <div style="margin-top: 15px">
                                <el-input v-model="voteURL" style="position: relative; z-index: 999"
                                    class="input-with-select" :readonly="true">
                                    <el-button slot="append" class="copyURL" @click="copyText">复制</el-button>
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="8" class="qrcode">
                            <img style="width: 140px; height: 140px" :src="qrcodeUrl" alt="" />
                            <p>扫一扫</p>
                            <p>分享到微信</p>
                        </el-col>
                    </el-row>
                    <el-row class="sendEmail">
                        <p style="margin: 10px 0">发送给参与人员</p>
                        <p style="color: #2b313c; font-size: 16px; margin: 0px">已关联活动：{{ currentItem.activityTitle }}
                        </p>
                    </el-row>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="bindActivityDialogVisible" custom-class="custom_el-dialog bindActivityDialog"
                title="绑定直播间" append-to-body width="920px" destroy-on-close @opened="onBindActivityDialogOpened"
                @closed="onBindActivityDialogClosed">
                <div style="display: flex; justify-content: space-between">
                    <el-form :inline="true" :model="bindActivitySearch" class="demo-form-inline">
                        <el-form-item label="直播间名称">
                            <el-input style="width: 240px" v-model="bindActivitySearch.title" placeholder="直播间名称"
                                @input="onBindActivitySearch"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="refreshBtn" @click="onBindActivityRefresh">
                        <i class="el-icon-refresh"></i>
                        刷新
                    </div>
                </div>
                <el-table ref="bindActivityListTable" :data="bindActivityList" style="width: 100%" height="340"
                    @selection-change="onBindActivityItemSelect">
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column prop="title" label="直播间名称"> </el-table-column>
                    <el-table-column label="直播间头图">
                        <template slot-scope="scope">
                            <el-image style="width: 160px; height: 90px" :src="scope.row.bannerUrl + '!banner'"
                                fit="cover"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ctime" label="创建时间"> </el-table-column>
                </el-table>
                <el-pagination layout="prev, pager, next" :current-page.sync="bindActivitySearch.pageNum"
                    :page-size.sync="bindActivitySearch.pageSize" :total="bindActivitySearch.total"
                    @current-change="onBindActivityPageChange">
                </el-pagination>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="bindActivityDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="onBindActivitySubmit">保 存</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import homeHeader from '@/components/homeHeader.vue';
import { survey, errors, interactionSurvey } from '@/services';
import conf from '@/config';
import copyText from 'ourwill-feutil/broswer/copyText'
const statusTotal = 'total';
export default {
    components: {
        homeHeader,
    },
    data() {
        return {
            searchForm: {
                status: statusTotal,
                searchText: '',
                pageNum: 1,
                pageSize: 10,
            },
            tableData: [],
            editDialogVisible: false,
            deleteDialogVisible: false,
            shareDialogVisible: false,
            currentItem: {},

            voteURL: '',
            config: {
                url: '', // 网址，默认使用 window.location.href
                source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
                title: '投票页面', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                description: '投票页面', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                image: '', // 图片, 默认取网页中第一个img标签
                sites: ['qzone', 'qq', 'wechat', 'weibo'], // 启用的站点
                disabled: [], // 禁用的站点
                wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
                wechatQrcodeHelper: '<p>扫一扫</p><p>分享到微信</p>',
            },
            qrcode: '',
            copyDialogVisible: false,

            selection: [],
            total: 0,
            bindActivityDialogVisible: false,
            bindActivitySearch: {
                title: '',
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            bindActivityList: [],
            bindActivitySelection: [],
        }
    },
    computed: {
        qrcodeUrl() {
            return `${conf.ssrUrl}/qrcode/png/${btoa(this.voteURL)}.png?s=200`;
        },
    },
    mounted() {
        this.getQuestionList();
    },
    methods: {
        async onBindActivityUnbind(item) {
            this.$confirm('确定解绑问卷吗?', '解绑问卷', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const { ok } = await interactionSurvey.cancelBoundActivity(item.id);
                    if (!ok) {
                        return
                    }
                    this.$message({
                        message: '解绑成功',
                        type: 'success',
                    });
                    this.currentItem.interactionSurveyList = this.currentItem.interactionSurveyList.filter(i => i.id !== item.id);
                    this.currentItem.activityNum = this.currentItem.interactionSurveyList.length;
                } catch (error) {
                    errors.handle(error);
                }
            }).catch(() => {
                
            });
        },
        onBindActivityListShow(row) {
            this.currentItem = row;
        },
        onBindActivitySearch() {
            this.bindActivitySearch.pageNum = 1;
            this.getBindActivityList();
        },
        onBindActivityPageChange(pageNum) {
            this.bindActivitySearch.pageNum = pageNum;
            this.getBindActivityList();
        },
        onBindActivityDialogOpened() {
            this.getBindActivityList();
        },
        onBindActivityDialogClosed() {
            this.bindActivitySelection = [];
        },
        onBindActivityItemSelect(val) {
            console.log(val, 888);
            this.bindActivitySelection = val;
        },
        async onBindActivitySubmit() {
            try {
                const { ok } = await interactionSurvey.boundActivityList(this.currentItem.id, this.bindActivitySelection.map(item => item.id));
                if (!ok) {
                    return
                }
                this.bindActivityDialogVisible = false;
                this.$message({
                    message: '绑定成功',
                    type: 'success',
                });
                this.getQuestionList();
            } catch (error) {
                errors.handle(error)
            }
        },
        onBindActivityRefresh() {
            this.getBindActivityList();
        },
        async getBindActivityList() {
            try {
                const { title, pageNum, pageSize } = this.bindActivitySearch;
                const { ok, data } = await interactionSurvey.getCanBindActivityList(this.currentItem.id, {
                    title,
                    pageNum,
                    pageSize,
                });
                if (!ok) {
                    return
                }
                this.bindActivityList = data.data.list || [];
                this.bindActivitySearch.total = data.data.total || 0;
            } catch (error) {
                errors.handle(error);
            }
        },
        goCreateEnroll() {
            this.$router.push({
                path: '/setQuestionnaire/noId/create/2',
            });
        },
        onSearch() {
            this.searchForm.pageNum = 1;
            this.getQuestionList();
        },
        async getQuestionList() {
            try {
                const { status, searchText, pageNum, pageSize } = this.searchForm;
                const { ok, data } = await survey.getQuestionnaireList({
                    status: status === statusTotal ? '' : status,
                    searchText,
                    pageNum,
                    pageSize,
                });
                if (ok) {
                    this.tableData = data.data.records || [];
                    this.total = data.data.total || 0;
                    this.selection = [];
                }
            } catch (error) {
                errors.handle(error);
            }
        },
        handleClick() {
            this.searchForm.pageNum = 1;
            this.getQuestionList();
        },
        goEditEnroll(row) {
            this.editDialogVisible = true;
            console.log(row);
            this.currentItem = row;
        },
        //编辑
        async editHandle() {
            const { ok, data } = await survey.checkInteraction(this.currentItem.id);
            if (!ok) {
                return
            }
            if(data.data && data.data.length > 0) {
                const activityTitles = data.data.map(item => item.activityTitle).join('、');
                this.$confirm(`该问卷当前已绑定“${activityTitles}”直播，并处于正在推送中。请前往该直播间，暂停推送问卷后再进行编辑。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    
                }).catch(() => {
                             
                });
            } else {
                this.editDialogVisible = false;
                this.$router.push({
                    path: `/setQuestionnaire/${this.currentItem.id}/edit/2`,
                });
            }
        },
        //复制后编辑
        copyEditHandle() {
            const id = this.currentItem.id;
            survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
                if (ok) {
                    this.$router.push({
                        path: `/setQuestionnaire/${data.data}/edit/2`,
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        //删除
        deleteEnroll(row) {
            this.$confirm('确定删除问卷吗?', '删除问卷', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const id = row.id;
                    const list = this.tableData;

                    survey.deleteQuestionnaireAndVote(id).then(({ data, ok }) => {
                        if (ok) {
                            this.$message.success(data.msg);
                            this.deleteDialogVisible = false;
                            if (list.length - 1 == 0) {
                                this.searchForm.pageNum -= 1
                            }
                            this.getQuestionList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } catch (error) {
                    errors.handle(error);
                }
            }).catch(() => {
                
            });
        },
        //更改发布
        switchChange(row) {
            const { id, status } = row;
            survey.setQuestionnaireAndVoteStatus(id).then(({ ok, data }) => {
                if (ok) {
                    if (data.flag && data.flag == 50002) {
                        this.$message.error(data.msg);
                        return;
                    }
                    if (!status) {
                        this.$message.success('发布成功');
                        row.status = 1;
                    } else {
                        this.$message.success('取消发布成功');
                        row.status = 0;
                    }

                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleCommand(command, row) {
            this.currentItem = row;
            if (command === 'statistics') {
                this.dataCount();
            } else if (command === 'copy') {
                this.onCopy()
            } else if (command === 'share') {
                this.shareHandle();
            }
        },
        dataCount() {
            const { id, title, totalNum } = this.currentItem;
            this.$router.push({
                name: 'questionnaireDataStatistics',
                params: { id: id, title: title, total: totalNum },
                query: { oldMark: 0, type: 2 },
            });
        },
        //分享
        shareHandle() {
            this.voteURL = `${conf.surveyHost}/questionnaire/#/questionnaireVote/${this.currentItem.id}/write`
            const activityId = this.currentItem.activityId;
            if (activityId) {
                survey.getSendNum(activityId).then(({ ok, data }) => {
                    if (ok) {
                        this.sendNum = data.data;
                    }
                });
            } else {
                this.sendNum = 0;
            }
            this.shareDialogVisible = true;

            if (!this.cl) {
                const self = this;
                setTimeout(() => {
                    const cl = new clipboard(this.$el.querySelector('.copyURL'));
                    cl.on('success', function (e) {
                        self.$message.success('复制成功');
                    });
                    cl.on('error', function (e) { });
                    this.cl = cl;
                }, 10);
            }
        },
        copyText() {
            copyText(this.voteURL);
        },
        onCopy() {
            this.$confirm('确认复制已选择的调查问卷吗?', '复制问卷', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.copyHandle();
            }).catch(() => {
                
            });
        },
        //复制
        copyHandle() {
            const id = this.currentItem.id;
            survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
                if (ok) {
                    this.$message.success(data.msg);
                    this.getQuestionList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        //选择删除
        handleSelectionChange(val) {
            this.selection = val;
            console.log(val);
        },
        onBatchDelete() {
            if (this.selection.length == 0) {
                this.$message.error('请选择要删除的调查问卷');
                return;
            }
            this.$confirm('确认删除已选择的调查问卷吗?', '删除问卷', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.batchDeleteHandle();
            }).catch(() => {
                
            });
        },
        //批量清空
        onBatchClear() {
            this.$confirm('确认清空全部调查问卷吗?', '清空问卷', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.clearHandle();
            }).catch(() => {
                
            });
        },
        //批量删除
        batchDeleteHandle() {
            const ids = this.selection.map(item => item.id);
            survey.batchDelete(ids).then(({ ok, data }) => {
                if (ok) {
                    this.$message.success(data.msg);
                    if (this.selection.length == this.tableData.length) {
                        this.searchForm.pageNum -= 1
                    }
                    this.getQuestionList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        clearHandle() {
            const { status } = this.searchForm;
            survey.delAll({ type: 2, status: status === statusTotal ? '' : status }).then(({ ok, data }) => {
                if (ok) {
                    this.$message.success(data.msg);
                    this.getQuestionList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        bindActivity(row) {
            this.bindActivityDialogVisible = true;
            this.currentItem = row;
        },
    },
}
</script>

<style lang="less">
.questionPage {
    overflow-x: hidden;

    .questionTabs {
        .el-tabs__content {
            display: none;
        }
    }

    .questionSearchForm {
        .el-button {
            i {
                font-size: 14px;

                +span {
                    margin-left: 8px;
                }
            }
        }
    }


    .editDialog {
        .el-dialog {
            padding: 0 123px;
            text-align: center;

            .el-dialog__header {
                padding: 0;
            }

            .el-dialog__body {
                padding: 40px 0 12px;

                .iconpark-icon {
                    height: 45px;
                    width: 45px;
                    margin-bottom: 22px;
                }

                .text {
                    display: block;
                    color: rgba(29, 33, 41, 1);
                    font-size: 12px;
                    line-height: 20px;
                    padding: 0 10px;
                }
            }

            .el-dialog__footer {
                padding: 12px 0 34px;

                span {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .el-button {
                        font-size: 14px;
                        height: 32px;
                        position: relative;
                        padding: 5px 16px;
                    }

                    .el-button--primary {
                        background: rgba(52, 145, 250, 1);
                        border: none;
                        color: rgba(255, 255, 255, 1);
                    }

                    .el-button--primary.is-plain {
                        background: rgba(242, 243, 245, 1);
                        border: none;
                        color: rgba(52, 145, 250, 1);
                    }

                    .el-button--default {
                        border: 1px solid rgba(134, 144, 156, 1);
                        color: rgba(78, 89, 105, 1);
                    }
                }
            }
        }
    }

    .copyAndDelDialog {
        .el-dialog {
            height: 188px;

            .el-dialog__header {
                font-size: 16px;
                color: #333333;
            }

            .el-dialog__body {
                padding-left: 58px;
                font-size: 14px;
                color: #333333;
            }

            .el-dialog__footer {
                padding: 0 20px 0 0;
            }
        }
    }

    .shareDialog {
        .el-dialog__header {
            padding-bottom: 20px;
            border-bottom: 1px solid #d8dbe0;
        }

        .el-input {
            .el-input-group__append {
                background-color: #2c7dfa;
                color: #fff;
            }
        }

        .sendEmail {
            height: 210px;
            border-top: 1px solid #d8dbe0;

            .sendBtn {
                text-align: center;
                margin-top: 50px;
                margin-bottom: 5px;
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: 0;

                .el-button {
                    width: 120px;
                    height: 42px;
                    background: #2c7dfa;

                    &.noSend {
                        background: #409eff;
                    }
                }

                .icon4 {
                    width: 16px;
                    height: 16px;
                    color: #fff;
                }

                .icon5 {
                    /*-webkit-transform: rotate(360deg);
                transform: rotate(360deg);
                -webkit-transition: -webkit-transform 1s linear;
                transition: transform 1s linear;*/
                    -webkit-animation: spin 1s linear 1s 5 alternate;
                    animation: spin 1s linear infinite;
                }
            }
        }

        .el-col-8 {
            text-align: center;
            box-sizing: border-box;
            padding-top: 10px;
            padding-bottom: 0;

            #qrcode {
                width: 120px;
                position: relative;
                left: 20px;
                margin-bottom: 10px;
            }

            p {
                margin: 0;
            }
        }

        .el-dialog__body {
            padding-bottom: 0px;

            .qrcode {
                padding: 0;
            }
        }

        .el-dialog__footer {
            height: 0;
            padding: 0;
        }
    }
}

.dropdown-item-content {
    display: flex;
    align-items: center;
    font-size: 14px;

    svg {
        margin-right: 8px;
    }

    &:hover {
        color: #2c7dfa;

        svg {
            fill: rgba(52, 145, 250, 1);
        }
    }
}

.bindActivityPopper {
    padding: 0;
}

.bindActivityList {
    padding: 12px 20px;
    max-height: 400px;
    overflow-y: auto;

    .bindActivityItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        &+.bindActivityItem {
            border-top: 1px solid #F2F6FC;
        }

        .activityTitle {
            width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            color: #393c42;
        }

        .activityId {
            margin-top: 4px;
            font-size: 14px;
            color: #909399;
        }
    }
}

.bindActivityDialog {
    .el-dialog__body {
        padding: 20px;
    }

    .el-link--primary {
        .el-link--inner {
            color: #2c7dfa;
        }
    }

    .el-dialog__footer {
        position: relative;
    }

    .selectSurveyInfo {
        font-size: 14px;
        line-height: 20px;
        color: rgba(43, 49, 60, 1);
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
    }

    .refreshBtn {
        display: flex;
        height: 40px;
        align-items: center;
        cursor: pointer;

        i {
            margin-right: 4px;
        }

        &:hover {
            color: #2c7dfa;
        }
    }
}
</style>